import { render, staticRenderFns } from "./TenantDeactivationCard.vue?vue&type=template&id=422506a2&scoped=true&"
import script from "./TenantDeactivationCard.vue?vue&type=script&lang=js&"
export * from "./TenantDeactivationCard.vue?vue&type=script&lang=js&"
import style0 from "./TenantDeactivationCard.vue?vue&type=style&index=0&id=422506a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422506a2",
  null
  
)

export default component.exports